import { useMemo } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { RegionViewModel } from 'functions/app/geography/view/region'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import {
  regionalPageLayoutTabs,
  regionTabs,
} from '@app/pages/discover/regions/constants'
import type { RegionFeatures } from '@schema/featureToggle'
import { useRegionalLayoutTabAvailability } from '@app/pages/discover/regions/regionalPage/useRegionalLayoutTabAvailability'
import { isRegionalLayoutTabAvailable } from '@app/pages/discover/regions/regionalPage/isRegionalLayoutTabAvailable'
import { pages } from '@app/util/links'
import { navigate } from 'wouter/use-browser-location'
import { useRegionalHeaderScroll } from '@app/pages/discover/regions/regionalPage/RegionalHeaderScrollContext'
import { GeographyNavBarShell } from '@app/components/blocks/navbar/shared/GeographyNavBarShell'

const layoutTabKeys = Object.values(regionalPageLayoutTabs)

export type RegionNavBarProps = {
  region: RegionViewModel
  tab: RegionFeatures
}

export const RegionNavBar = ({ region, tab }: RegionNavBarProps) => {
  const isMobile = useMediaQuery()
  const [language] = useLanguage()
  const translations = i18n.languages[language].app.regionPage
  const { context } = useRegionalLayoutTabAvailability(region)
  const { showRegionName } = useRegionalHeaderScroll()
  const isOverviewTab = tab === regionTabs.overview
  const shouldShowEntityName = !isOverviewTab || showRegionName

  const tabs = useMemo(
    () =>
      layoutTabKeys.map((key) => ({
        value: key,
        label: translations[key],
        isVisible: isRegionalLayoutTabAvailable(region, key, context),
      })),
    [translations, region, context],
  )

  const handleSelectTab = (key: RegionFeatures) => {
    navigate(pages.regionPageNew(region.slug, key))
  }

  return (
    <GeographyNavBarShell
      isMobile={isMobile}
      shouldShowEntityName={shouldShowEntityName}
      entityName={region.name}
      homePath={pages.regionPageNew(region.slug)}
      tab={tab}
      tabs={tabs}
      onSelectTab={(key) => handleSelectTab(key as RegionFeatures)}
    />
  )
}
